module.exports = __webpack_public_path__ + "static/media/ve.eaf80352.svg";